import { Label,Link, Stack, StackItem, Text } from '@fluentui/react';
import * as React from 'react';
import { IEventRegistrationDetail } from '../../../Models/Registration/IEventRegistrationDetail';
import { formatUrl } from '../../../Services/API/ApiHelpers';
import { backendUrl } from '../../../Services/ConfigureService';


interface IRegistrationDetailViewProps {
    registration?: IEventRegistrationDetail
    isLoading: boolean;
    isAdmin: boolean;
}


export const RegistrationDetailView: React.FunctionComponent<IRegistrationDetailViewProps> = (props) => {

    return (
        <Stack tokens={{ childrenGap: 15 }} styles={{ root: { paddingTop: 40 } }}>
            <Stack horizontal verticalAlign="center">
                <Stack.Item styles={{ root: { minWidth:100 } }}>
                    <Label>Název</Label>
                </Stack.Item>
                <Stack.Item grow>
                    <Text>{props.registration?.eventName}</Text>
                </Stack.Item>
            </Stack>
            <Stack horizontal verticalAlign="center">
                <Stack.Item styles={{ root: { minWidth: 100 } }}>
                    <Label>Popis</Label>
                </Stack.Item>
                <Stack.Item grow>
                    <Text>{props.registration?.eventDescription}</Text>
                </Stack.Item>
            </Stack>

            <Stack horizontal verticalAlign="center">
                <Stack.Item styles={{ root: { minWidth: 100 } }}>
                    <Label>Místo konání</Label>
                </Stack.Item>
                <Stack.Item grow>
                    <Stack>
                        <Text>{props.registration?.roomName}</Text>
                        <Text>{props.registration?.roomNameDistrict}</Text>
                        <Text>{props.registration?.RoomDescription}</Text>
                        {(props.registration?.roomLat && props.registration?.roomLat != 0 && props.registration?.roomLon != 0) ?
                            <Link href={"https://www.google.com/maps/search/?api=1&query=" + props.registration?.roomLat + "," + props.registration?.roomLon} target="_blank">Zobrazit na mapě</Link>
                            :null}
                    </Stack>
                </Stack.Item>
            </Stack>

            <Stack horizontal verticalAlign="center">
                <Stack.Item styles={{ root: { minWidth: 100 } }}>
                    <Label>První lekce</Label>
                </Stack.Item>
                <Stack.Item grow>
                    <Text>{props.registration?.firstLesson.toLocaleDateString("cs-CZ")}</Text>
                </Stack.Item>
            </Stack>
            {props.registration?.attendees ?
                <Stack horizontal verticalAlign="start" >
                    <Stack.Item styles={{ root: { minWidth: 100, verticalAlign:'start' } }}>
                        <Label>{props.registration.attendees.length > 1 ? "Přihlášení žáci":"Přihlášený žák"}</Label>
                    </Stack.Item>
                    <Stack.Item grow>
                        <Stack verticalAlign="start">
                            {props.registration?.attendees.map(item =>
                                <Stack horizontal>
                                    <StackItem styles={{ root: { width:160 } }}>
                                        <Text>{item.firstName + " " + item.lastName}</Text>
                                    </StackItem>
                                    <StackItem>
                                        <Link target="_black" href={formatUrl(backendUrl(), `/api/pdf/GetApplication?id=` + item.id)} onClick={() => { }}>Stáhnout přihlášku</Link>
                                    </StackItem>
                                </Stack>
                            )}
                        </Stack>
                    </Stack.Item>
                </Stack>
                : null}
        </Stack>
    )
}
